import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import { IconButton, InputAdornment, TextField } from '@mui/material';
import { useState } from 'react';

import { useT } from '../i18n/LanguageContext';

type RevealablePasswordFieldProps = {
  label: string;
  value: string;
  onChange: (next: string) => void;
  autoComplete: 'current-password' | 'new-password';
  autoFocus?: boolean;
};

/** A person's own password: masked, with a button to show it. */
export const RevealablePasswordField = ({
  label,
  value,
  onChange,
  autoComplete,
  autoFocus = false,
}: RevealablePasswordFieldProps) => {
  const t = useT();
  const [revealed, setRevealed] = useState(false);

  return (
    <TextField
      label={label}
      type={revealed ? 'text' : 'password'}
      size="medium"
      value={value}
      onChange={(event) => onChange(event.target.value)}
      autoComplete={autoComplete}
      autoFocus={autoFocus}
      required
      fullWidth
      InputProps={{
        endAdornment: (
          <InputAdornment position="end">
            <IconButton
              edge="end"
              aria-label={revealed ? t('password.hide') : t('password.show')}
              aria-pressed={revealed}
              onClick={() => setRevealed((previous) => !previous)}
            >
              {revealed ? <VisibilityOffIcon /> : <VisibilityIcon />}
            </IconButton>
          </InputAdornment>
        ),
      }}
    />
  );
};
